module.exports = __webpack_public_path__ + "media/images/stock_groups/e2eb-88f7dc0e4c664c30d3385bb6b3780d12.svg";